import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Container, Divider, FormControl, FormLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField, Theme, Typography, createStyles, makeStyles, colors, CircularProgress } from '@material-ui/core';
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { HubBand } from '../app/utils/models';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createNewHubModel, updateNewHubModel, removeNewHubModel, getHubModels, getBladeModelList, newProjectResponse } from "../app/reducer/hubModal.reducer";
import { useAppSelector } from "../app/hooks";
import AlertComponent from "../components/general/Alert";
import { FanUploadProps } from './Fans'
import DeleteDialog from './DeleteDialog';
import Paths from '../utils/Paths';
import AlertDialog from './AlertDialog';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    redOutline: {
      borderColor: "red !important"
    },
    uppercaseText: {
      textTransform: 'uppercase'
    }
  }),
);

const USER_ACTION = {
  EDIT_DATA: "EDIT_DATA",
  VIEW_DATA: "VIEW_DATA",
  DUPLICATE_DATA: "DUPLICATE_DATA",
  DELTE_DATA: "DELETE_DATA"
}

const BUTTON_NAMES = {
  EDIT: "EDIT",
  DUPLICATE: "DUPLICATE",
  DELETE: "DELETE",
  FULL_BACK: "FULL_BACK",
  SUBMIT: "SUBMIT",
  PARTIAL_BACK: "PARTIAL_BACK",
  DUPLICATE_INFO_TEXT: "DUPLICATE_INFO_TEXT",
  PARTIAL_UPDATE: "PARTIAL_UPDATE"
}

const CONTROLS_VIEW_CONFIG:any = {
  "VIEW_DATA": ["EDIT","DUPLICATE","DELETE","FULL_BACK","PARTIAL_UPDATE"],
  "EDIT_DATA": ["PARTIAL_BACK","SUBMIT"],
  "DUPLICATE_DATA": ["PARTIAL_BACK","SUBMIT","DUPLICATE_INFO_TEXT"],
}

export default function Hubs({ setIndex, hubID, setVisibleModule,isFromFanList,footerDisable }: FanUploadProps) {

  const { register, handleSubmit, setValue, getValues, control, formState: { errors }, setError, reset } = useForm<HubBand>();
  const classes = useStyles();
  const dispatch = useDispatch()
  const history = useHistory();

  const [value, setSelectedValue] = useState<string | null>(null);
  const [inputValue, setInputValue] = useState('');
  const [bladeModels, setBladeModels] = useState<any[] | undefined>([]);
  const [options, setOptions] = useState<string[]>([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [buttonAction, setButtonAction] = useState<string>('Edit');
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [openAlertMesage, setOpenAlertMessage] = React.useState<string>("");
  const [userAction,setUserAction] = useState(USER_ACTION.VIEW_DATA);
  const [openDeleteModal,setOpenDeleteModal] = useState(false);
  const [duplicateBandId,setDuplicateBandId] = useState("");
  const [hubList,setHubList] = useState<string[]>([]);
  const [tempHubId,setTempHubId] = useState<string>("");
  const [warningDialog,setWarningDialog] = useState(false);
  const [warningDialogText,setWarningDialogText] = useState("");
  const [loading,setLoading] = useState(false);
  
  const modelList:any = useAppSelector(getBladeModelList);
  const newProjectResponses = useAppSelector(newProjectResponse);

  const cache: any = {};
  const memoizedGetBladeModels = async () => {
    if (cache.bladeModels) {
      return cache.bladeModels;
    }
    const bladeModels = await dispatch(getHubModels());
    cache.bladeModels = bladeModels;

    return bladeModels;
  };

  const fetchUpdatedData = async () => {
    const bladeModels = await memoizedGetBladeModels();
    const modelList = bladeModels.payload.data
    setBladeModels(modelList)
    const options = modelList ? modelList.map((item: any) => item?.hubID) : [];
    setHubList(options.sort())
    setOptions(options.sort())
  }


  const miniRefresh = async () => {
    setLoading(true);
    const bladeModels:any = await dispatch(getHubModels());
    const { newValues, selectedItem } = updateNewValuesAftreRefresh(hubID,bladeModels.payload.data)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
    setBladeModels(bladeModels.payload.data);
    setLoading(false);
  }

  function disableParentFooter() {
    if(isFromFanList)
      footerDisable(true)
  }

  function enableParentFooter() {
    if(isFromFanList)
      footerDisable(false)
  }



  useEffect(() => {
    (async () => {
      setLoading(true);
      if (setIndex) {
        setIndex(2);
      }
      debugger;
      await fetchUpdatedData(); // Wait for fetchUpdatedData to complete
      if (hubID) {
                setSelectedValue(hubID);
        const { newValues, selectedItem } = updateNewValues(hubID);
        Object.keys(newValues).forEach((fieldName: any) => {
          setValue(fieldName, selectedItem[fieldName]);
        });
      }
      setLoading(false);
    })();
  }, []);

  const updateNewValuesAftreRefresh = (inputValue: any,models: any) => {
    const selectedItem = models?.find((item:any) => item.hubID == inputValue)
      const newValues: any = {
      hubID: selectedItem.hubID,
      hubDiameter: selectedItem.hubDiameter,
      hubMaterial: selectedItem.hubMaterial,
      hubWeight: selectedItem.hubWeight,
      clampMaterial: selectedItem.clampMaterial,
      numofBlades: selectedItem.numofBlades,
      platType: selectedItem.platType,
    };
    return { newValues: newValues, selectedItem: selectedItem };
  }


  const updateNewValues = (inputValue: any) => {
    const selectedItem = bladeModels && bladeModels?.find(item => item.hubID == inputValue)
    console.log({
      bladeModels: bladeModels,
      selectedItem: selectedItem
    })
    if (!bladeModels?.length || !selectedItem) {
      return { newValues: {}, selectedItem: {} };
    }
        const newValues: any = {
      hubID: selectedItem.hubID,
      hubDiameter: selectedItem.hubDiameter,
      hubMaterial: selectedItem.hubMaterial,
      hubWeight: selectedItem.hubWeight,
      clampMaterial: selectedItem.clampMaterial,
      numofBlades: selectedItem.numofBlades,
      platType: selectedItem.platType,
    };
    return { newValues: newValues, selectedItem: selectedItem };
  }


  const handleAddNewItem = () => {
    if (inputValue.trim() && !options.includes(inputValue)) {
      setOptions([...options, inputValue]);
      setSelectedValue(inputValue);
    }
    if (options.length == 0) {
      fetchUpdatedData();
    }
  };

  const onSubmit: SubmitHandler<HubBand> = async data => {
    if(hubID)
      setTempHubId(hubID);
    if(userAction === USER_ACTION.DUPLICATE_DATA && hubList.includes(inputValue))
      return;
    let newData = { ...data, hubID: inputValue };
    if (newData.hubID != "") {
      if (buttonAction == "Edit") {
        await dispatch(updateNewHubModel(newData));
        setOpenAlertMessage('HUB data updated successfully')
        reset();
      } else {
        await dispatch(createNewHubModel(newData));
        if (!newProjectResponses) {
          setOpenAlertMessage('New HUB created successfully');
          reset();
        }
      }
      setOpenAlert(true);
      setUserAction(USER_ACTION.VIEW_DATA);
    }
  };

  const onInputChange = (event: any, newInputValue: any, reason: string) => {
    if(reason === "clear" && userAction !== USER_ACTION.DUPLICATE_DATA)
      reset();
        setInputValue(newInputValue);
    // if (setVisibleModule) {
    //   setVisibleModule(newInputValue);
    // }
    if (!bladeModels && !inputValue) {
      return false;
    }
    const { newValues, selectedItem } = updateNewValues(newInputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }

  const editField = () => {
    // + If the input value is empty, don't allow editing.
    if(inputValue.length<=0) {
      setWarningDialog(true);
      setWarningDialogText("Please select a Hub ID for edit.");
      return;
    }
    setUserAction(USER_ACTION.EDIT_DATA);
    disableParentFooter()
    // if(hubID){
    //   history.push('/hubs',{selectedValue:hubID})
    // }
    setButtonAction("Edit");
    if (!bladeModels && !inputValue) {
      return false;
    }
    setDuplicateBandId(inputValue);
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }

  const duplicateField = () => {
    if(inputValue.length<=0) {
      setWarningDialog(true);
      setWarningDialogText("Please select a Hub ID to duplicate.");
      return;
    }
    setButtonAction("Duplicate");
    setUserAction(USER_ACTION.DUPLICATE_DATA);
    setDuplicateBandId(inputValue);
    if (!bladeModels && !inputValue) {
      return false
    }
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }


  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if(inputValue === null || inputValue === undefined || inputValue === "") {
      setWarningDialog(true);
      setWarningDialogText("Please select a Hub ID for deletion.");
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    handleClose();
    setOpenAlertMessage('Deleted HUB successfully');
    setOpenAlert(true);
  };

  const refresh = async () => {
    if(hubID) {
      await miniRefresh();
      setUserAction(USER_ACTION.VIEW_DATA);
      enableParentFooter();
      return;
    }
    fetchUpdatedData();
    history.go(0);
  }

  const onDelete = async () => {
    setButtonAction("Delete");
    if (!bladeModels && !inputValue) {
      return false
    }
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
    await dispatch(removeNewHubModel(newValues));
    setOpenAlertMessage('Deleted HUB successfully');
    setOpenAlert(true);
  }

  const isDisable = () => {
    if(userAction === USER_ACTION.EDIT_DATA || userAction === USER_ACTION.DUPLICATE_DATA)
      return false;
    return true;
  }

  const isDisableForAutoComplete = () => {
    if(userAction === USER_ACTION.EDIT_DATA)
      return true;
    return false;
  }

  const isVisible = (controlName:any) => {
    const allowableList = CONTROLS_VIEW_CONFIG[userAction];
    return allowableList.includes(controlName);
  }

  const isPartialButtonVissible = ():any => {
    return isFromFanList && isVisible(BUTTON_NAMES.PARTIAL_UPDATE);
  }

  // const onPartialUpdate = () => {
  //   debugger;
  //   if(setVisibleModule && inputValue) {
  //     setVisibleModule(inputValue);
  //     setWarningDialog(true);
  //     setWarningDialogText("New Hub Updated.")
  //   }
  // }
const onPartialUpdate = () => {
  if (setVisibleModule && inputValue) {
    const hubDiameter = getValues('hubDiameter'); // get current hubDiameter from form
    setVisibleModule({
      hubID: inputValue,
      hubDiameter: hubDiameter
    });
    setWarningDialog(true);
    setWarningDialogText("New Hub Updated.");
  }
}
  return (
    <div className="page-wrapper">
      <Container maxWidth="xl">
        <Paper className="form-wrapper">
          <Typography variant="h5" gutterBottom>
            <b className={classes.uppercaseText}> {buttonAction} Hub Model Details</b>
          </Typography>
          <hr />
          <Divider />
          <AlertDialog open={warningDialog} message={warningDialogText} handleClose={() => setWarningDialog(false)} />
          <DeleteDialog open={open} handleClose={handleClose} path={Paths.Hub} idType="hubID" id={inputValue} handleDelete={handleDelete}/>
          <AlertDialog  open={openAlert} message={openAlertMesage} handleClose={() => { setOpenAlert(false);refresh(); }} />
          {/* <AlertComponent open={openAlert} message={openAlertMesage} severity="success" handleClose={() => { setOpenAlert(false) }} /> */}

          <form id="fan-details-form" style={{ padding: '5px' }} onSubmit={handleSubmit(onSubmit)}>
            {(!inputValue || hubList.includes(inputValue)) && (buttonAction == 'Duplicate') && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>Add new model number</p>
            )}
            {inputValue && buttonAction == 'Duplicate' && newProjectResponses?.error?.errors[0].bladeModel && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>{newProjectResponses?.error?.errors[0].bladeModel}</p>
            )}


            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <Autocomplete
                  disabled={isDisableForAutoComplete()}
                  value={value}
                  inputValue={inputValue}
                  onInputChange={onInputChange}
                  options={options}
                  freeSolo
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      label="Select or add new HubID"
                      variant="outlined"
                    />
                  )}

                  onBlur={handleAddNewItem}
                  onKeyDown={(event: any) => {
                    if (event.key === 'Enter') {
                      handleAddNewItem();
                    }
                  }}
                />
              </Grid>
              {isVisible(BUTTON_NAMES.EDIT) &&
                <Grid item xs={12} lg={2}>
                  <Button variant="contained" color="primary" onClick={editField} style={{ width: '180px',backgroundColor:'#41bb98' }}>EDIT HUB</Button>
                </Grid>
              }
              {
                (hubID && isVisible(BUTTON_NAMES.SUBMIT)) && (
                  <Grid item xs={12} lg={2}>
                    <Button variant="contained" color="primary" type='submit'>{buttonAction} Submit</Button>
                  </Grid>
                )
              }
              {isPartialButtonVissible() && (
                <Grid item xs={12} lg={2}>
                <Button variant="contained" style={{color:'white'}} color="secondary" type='button' onClick={onPartialUpdate}>Update</Button>
                </Grid>)
              }
              {isVisible(BUTTON_NAMES.PARTIAL_BACK) && (
                <Grid item xs={12} lg={2}>
                  <Button variant="contained" color="primary" onClick={() =>  {
                      if(userAction === USER_ACTION.DUPLICATE_DATA) {
                        setInputValue(duplicateBandId);
                        onInputChange(null,duplicateBandId,"REFRESH")
                      }
                      if(userAction === USER_ACTION.EDIT_DATA){
                        onInputChange(null,duplicateBandId,"REFRESH")
                      }
                      setButtonAction("Edit");
                      setUserAction(USER_ACTION.VIEW_DATA) 
                      if(isFromFanList)
                        footerDisable(false)
                  }
                } style={{ width: '180px',backgroundColor:'#41bb98' }}>Back</Button>
                </Grid>)
              }
              { (!hubID && !isFromFanList ) && (
                <>
                  {isVisible(BUTTON_NAMES.DUPLICATE) &&
                    <Grid item xs={12} lg={2}>
                      <Button variant="contained" color="secondary" style={{ color:'white', backgroundColor: 'rgb(245 154 36)' }} onClick={duplicateField}>DUPLICATE HUB</Button>
                    </Grid>
                  }
                  {isVisible(BUTTON_NAMES.DELETE) &&
                    <Grid item xs={12} lg={2}>
                      <Button type="button" variant="contained" color="secondary" style={{ color:'white', backgroundColor: 'rgba(217, 0, 27, 1)' }} onClick={handleOpen}>DELETE HUB</Button>
                    </Grid>
                  }
                </>)
              }
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Hub Diameter (m)"
                  variant="outlined" fullWidth
                  {...register("hubDiameter", { required: true })}
                  helperText={errors.hubDiameter ? 'This field is required' : ''}
                  disabled={isDisable()}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Hub Material"
                  variant="outlined" fullWidth
                  {...register("hubMaterial", { required: true })}
                  helperText={errors.hubMaterial ? 'This field is required' : ''}
                  disabled={isDisable()}
                />
              </Grid>

              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Hub Weight (kg)"
                  variant="outlined" fullWidth
                  {...register("hubWeight", { required: true })}
                  helperText={errors.hubWeight ? 'This field is required' : ''}
                  disabled={isDisable()}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Clamp Material"
                  variant="outlined" fullWidth
                  {...register("clampMaterial", { required: true })}
                  helperText={errors.clampMaterial ? 'This field is required' : ''}
                  disabled={isDisable()}
                />
              </Grid>


              <Grid item xs={12} lg={3}>

                <FormControl variant="outlined" className={classes.formControl} >
                  <InputLabel>Plate Type</InputLabel>
                  <Controller
                    control={control}
                    name="platType"
                    defaultValue="axial"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        label="Plate Type"
                        value={value}
                        {...register("platType", { required: true })}
                        disabled={isDisable()}
                      >
                        <MenuItem value="Double">Double</MenuItem>
                      </Select>
                    )}

                  />
                </FormControl>

              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="No. of Blades"
                  variant="outlined" fullWidth
                  {...register("numofBlades", { required: true })}
                  helperText={errors.numofBlades ? 'This field is required' : ''}
                  disabled={isDisable()}
                />
              </Grid>
            </Grid>
            { !hubID && 
              <>
            {isVisible(BUTTON_NAMES.SUBMIT) &&
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12} lg={12}>
                  <Button variant="contained" color="primary" type='submit'>{buttonAction} Submit</Button>
                </Grid>
              </Grid>
            }
             {(!isFromFanList && isVisible(BUTTON_NAMES.FULL_BACK)) &&
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12} lg={12}>
                  <Button variant="contained" style={{backgroundColor:'#6b6666'}} color="primary" type='button' onClick={() => history.goBack()}>BACK</Button>
                </Grid>
              </Grid>
            }</>}
          </form>
        </Paper>

        <Dialog open={loading} aria-labelledby="delete-dialog-title">
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      </Container>
    </div>
  );

}

